import React, { Component } from "react";
import { DatePicker, Select, Spin, message, Radio, Space } from "antd";
import Bridge from "../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import { US_STATES, COUNTRY_LIST, CURRENT_RESIDENCE_COUNTRY_OPTIONS } from "../../utils/consts";
import { logEvent } from "../../utils/analytics";

const { Option } = Select;

export default class PersonalInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      middle_name: "",
      date_of_birth: null,
      city: "",
      state_country: "",
      marital_status: "",
      loading: false,
      birth_location: "",
      us_city: "",
      us_state: "",
      us_country: "",
      other_birth_city: "",
      other_birth_state: "",
      other_birth_country: "",
      reside_in_city: "",
      reside_in_state: "",
      reside_in_country: "",
      marital_status_list: [
        "Single",
        "Separated",
        "Married",
      ],
      other_us_territory: "",
      other_reside_in_state: ""
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.ecas_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "FirstName") {
                this.setState({ first_name: item.value });
              }
              if (item.field == "MiddleName") {
                this.setState({ middle_name: item.value });
              }
              if (item.field == "LastName") {
                this.setState({ last_name: item.value });
              }
              if (item.field == "Date Of Birth") {
                this.setState({
                  date_of_birth: item.value ? dayjs(item.value) : null,
                });
              }
              if (item.field == "Marital Status") {
                this.setState({ marital_status: item.value });
              }
              if (item.field == "Place of Birth") {
                this.setState({ birth_location: item.value });
              }
              if (
                item.field == "If Place of Birth Country is US, then City Name"
              ) {
                this.setState({ us_city: item.value });
              }
              if (
                item.field == "If Place of Birth Country is US, then State Name"
              ) {
                this.setState({ us_state: item.value });
              }
              if (
                item.field ==
                "If Place of birth country is not US, then country Name"
              ) {
                this.setState({ other_birth_country: item.value });
              }
              if (
                item.field ==
                "If Place of birth country is not US, then city Name"
              ) {
                this.setState({ other_birth_city: item.value });
              }
              if (
                item.field ==
                "If Place of birth country is not US, then state Name"
              ) {
                this.setState({ other_birth_state: item.value });
              }
              if (item.field == "City within the United States") {
                this.setState({ reside_in_city: item.value });
              }
              if (item.field == "State within the United States") {
                this.setState({ reside_in_state: item.value });
              }
              if (item.field == "Country you reside in") {
                this.setState({ reside_in_country: item.value });
              }
              if (item.field == "Other US Territory") {
                this.setState({ other_us_territory: item.value });
              }
              if (item.field == "Other Us Territory - Reside in State") {
                this.setState({ other_reside_in_state: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  validateName = (field, label) => {
    // Check if the input contains only alphabetic characters
    // if (!/^[A-Za-z]+$/.test(field)) {
    //   // message.warning(`${label} can only contain alphabetic characters.`);
    //   return `${label} can only contain alphabetic characters.`;
    // }
    // Check if the length of the input is within a specific range
    if (field.length <= 2 || field.length > 30) {
      // message.warning(`${label} must be between 2 and 30 characters long.`);
      return `${label} must be between 2 and 30 characters long.`;
    }
    return 1;
  };
  // step 1
  save_details = (goToNextStep = true) => {
    if (goToNextStep) {
      if (!this.state.first_name) {
        message.warning("First name is required");
        return;
      }
      const validateFirstName = this.validateName(
        this.state.first_name,
        "First Name"
      );
      if (validateFirstName != 1) {
        message.warning(validateFirstName);
        return;
      }
      if (!this.state.last_name) {
        message.warning("Last name is required");
        return;
      }
      const validateLastName = this.validateName(
        this.state.last_name,
        "Last Name"
      );
      if (validateLastName != 1) {
        message.warning(validateLastName);
        return;
      }
      if (!this.state.date_of_birth) {
        message.warning("Date of birth is required");
        return;
      }
      let last18YearsStartDate = moment().subtract(18, "years");
      last18YearsStartDate = moment(last18YearsStartDate).format("YYYY-MM-DD");
      let dob2 = dayjs(this.state.date_of_birth).format("YYYY-MM-DD");
      if (dob2 > last18YearsStartDate) {
        message.warning(
          "Min Age must be 18 Years. Please select valid Date Of birth"
        );
        return;
      }
      //30 max

      if (!this.state.birth_location) {
        message.warning("Place of birth is required");
        return;
      }
      if (this.state.birth_location == "United States") {
        if (!this.state.us_city) {
          message.warning("City of birth is required");
          return;
        }
        if (!this.state.us_state) {
          message.warning("State of birth is required");
          return;
        }
      }
      if (this.state.birth_location == "Outside the United States") {
        if (!this.state.other_birth_country) {
          message.warning("Please specify the country of birth.");
          return;
        }
        if (!this.state.other_birth_city) {
          message.warning("Please specify the city of birth when country is not United States.");
          return;
        }
        if (!this.state.other_birth_state) {
          message.warning("Please specify the state of birth when country is not United States.");
          return;
        }
      }

      if (!this.state.reside_in_state) {
        message.warning("State of current residence is required");
        return;
      }
      if (!this.state.reside_in_city) {
        message.warning("City of current residence is required");
        return;
      }
    }

    let dob = dayjs(this.state.date_of_birth).format("MM/DD/YYYY");
    const saveForLater = !goToNextStep;

    // Check which mandatory Personal Information fields are missing
    let missingFields = [];
    if (!this.state.first_name || this.validateName(this.state.first_name, "First Name") != 1) missingFields.push("First Name");
    if (!this.state.last_name || this.validateName(this.state.last_name, "Last Name") != 1) missingFields.push("Last Name");
    const last18YearsStartDate = moment().subtract(18, "years").format("YYYY-MM-DD");
    if (!this.state.date_of_birth || dayjs(this.state.date_of_birth).format("YYYY-MM-DD") > last18YearsStartDate) missingFields.push("Date of Birth");
    if (!this.state.birth_location) missingFields.push("Place of Birth");
    else if (this.state.birth_location === "United States") {
      if (!this.state.us_city) missingFields.push("City of Birth");
      if (!this.state.us_state) missingFields.push("State of Birth");
    } else if (this.state.birth_location === "Outside the United States") {
      if (!this.state.other_birth_country) missingFields.push("Country of Birth");
      if (!this.state.other_birth_city) missingFields.push("City of Birth");
      if (!this.state.other_birth_state) missingFields.push("State of Birth");
    }
    if (!this.state.reside_in_state) missingFields.push("State of Current Residence");
    if (!this.state.reside_in_city) missingFields.push("City of Current Residence");

    const isPersonalInfoComplete = missingFields.length === 0 ? 1 : 0;

    let questions = [
      ...(saveForLater
        ? [
          {
            parent_field: "Save",
            field: "Save for later date",
            value: dayjs().format("MM/DD/YYYY HH:mm"),
          },
        ]
        : []),
      {
        parent_field: "Personal Information Save Type",
        field: "Personal Information Save Type",
        value: saveForLater ? "Save for Later" : "Save Personal Info",
      },
      {
        parent_field: "Is Personal Information Fields Submitted",
        field: "Is Personal Information Fields Submitted",
        value: isPersonalInfoComplete,
      },
      {
        parent_field: "Personal Information Missing Fields",
        field: "Personal Information Missing Fields",
        value: JSON.stringify(missingFields),
      },
      {
        parent_field: "FirstName",
        field: "FirstName",
        value: this.state.first_name,
      },
      {
        parent_field: "MiddleName",
        field: "MiddleName",
        value: this.state.middle_name,
      },
      {
        parent_field: "LastName",
        field: "LastName",
        value: this.state.last_name,
      },
      {
        parent_field: "Date Of Birth",
        field: "Date Of Birth",
        value: this.state.date_of_birth ? dob : "",
      },
      {
        parent_field: "Marital Status",
        field: "Marital Status",
        value: this.state.marital_status,
      },
      {
        parent_field: "Place of Birth",
        field: "Place of Birth",
        value: this.state.birth_location,
      },
      {
        parent_field: "If Place of Birth Country is US, then City Name",
        field: "If Place of Birth Country is US, then City Name",
        value: this.state.us_city,
      },
      {
        parent_field: "If Place of Birth Country is US, then State Name",
        field: "If Place of Birth Country is US, then State Name",
        value: this.state.us_state,
      },
      {
        parent_field: "If Place of birth country is not US, then country Name",
        field: "If Place of birth country is not US, then country Name",
        value: this.state.other_birth_country,
      },
      {
        parent_field: "If Place of birth country is not US, then city Name",
        field: "If Place of birth country is not US, then city Name",
        value: this.state.other_birth_city,
      },
      {
        parent_field: "If Place of birth country is not US, then state Name",
        field: "If Place of birth country is not US, then state Name",
        value: this.state.other_birth_state,
      },
      {
        parent_field: "Current Residence",
        field: "City within the United States",
        value: this.state.reside_in_city,
      },
      {
        parent_field: "Current Residence",
        field: "State within the United States",
        value: this.state.reside_in_state,
      },
      {
        parent_field: "Country you reside in",
        field: "Country you reside in",
        value: this.state.reside_in_country,
      },
      {
        parent_field: "Other US Territory",
        field: "Other US Territory",
        value: this.state.other_us_territory
      },
      {
        parent_field: "Other Us Territory - Reside in State",
        field: "Other Us Territory - Reside in State",
        value: this.state.other_reside_in_state,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "1",
      action_type: this.props.is_update == true ? "update" : "insert",
      ...(saveForLater && { save_for_later: true }),
    };
    this.setState({ loading: true });
    Bridge.demographics.ecas_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_saved", { section: "personal_info" });
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(2);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3>PERSONAL INFORMATION</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2 input-heading">
                First Name <span className="text-danger">*</span>
              </label>
              <br />
              <input
                type="text"
                name="first_name"
                value={this.state.first_name}
                onChange={(e) => this.setState({ first_name: e.target.value })}
                maxLength={30}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Middle Name
              </label>
              <br />
              <input
                type="text"
                name="middle_name"
                value={this.state.middle_name}
                maxLength={30}
                onChange={(e) => this.setState({ middle_name: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Last Name <span className="text-danger">*</span>
              </label>
              <br />
              <input
                type="text"
                name="last_name"
                value={this.state.last_name}
                onChange={(e) => this.setState({ last_name: e.target.value })}
                maxLength={30}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Date of Birth?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <DatePicker
                onChange={this.onChange}
                format={"MM/DD/YYYY"}
                disabledDate={disabledDate}
                value={this.state.date_of_birth}
                className="ecas-personal-info-control"
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Place of birth <span className="text-danger">*</span>
              </label>
              <br />
              <div className="row">
                <div className="col-lg-7">
                  <Select
                    onChange={(value) =>
                      this.setState(
                        {
                          birth_location: value,
                        },
                        () => {
                          this.setState({
                            us_city: "",
                            us_state: "",
                            us_country: "",
                            other_birth_country: "",
                            other_us_territory: ""
                          });
                        }
                      )
                    }
                    value={this.state.birth_location}
                    className="ecas-personal-info-control"
                  >
                    <Option value="">Select Country</Option>
                    <Option value="United States">United States</Option>
                    <Option value="Outside the United States">Outside the United States</Option>
                  </Select>
                </div>
                <div className="col-lg-5"></div>
                {this.state.birth_location == "United States" && (
                  <div className="row mt-3">
                    <div className="col-lg-6 mt-3">
                      <Select
                        onChange={(value) =>
                          this.setState(
                            { us_state: value, other_us_territory: "" }
                          )
                        }
                        value={this.state.us_state}
                        className="col-lg-12 pr-2 ecas-personal-info-control"
                      >
                        <Option value="">Select State</Option>
                        {US_STATES.map((state, index) => (
                          <Option value={state} key={index}>{state}</Option>
                        ))}
                      </Select>

                      {this.state.us_state == "Other US Territory" && (
                        <input
                          type="text"
                          value={this.state.other_us_territory}
                          onChange={(e) =>
                            this.setState({
                              other_us_territory: e.target.value,
                            })
                          }
                          placeholder="Enter other US Territory"
                          className="mt-2"
                        />
                      )}
                    </div>
                    <div className="col-lg-6 mt-3">
                      <input
                        type="text"
                        placeholder="City"
                        name="us_city"
                        value={this.state.us_city}
                        onChange={(e) =>
                          this.setState({ us_city: e.target.value })
                        }
                      />
                    </div>
                  </div>
                )}
                {this.state.birth_location == "Outside the United States" && (
                  <div className="row mt-3">
                    <div className="col-lg-4 mt-3">
                      <Select
                        onChange={(value) =>
                          this.setState(
                            { other_birth_country: value }
                          )
                        }
                        value={this.state.other_birth_country}
                        className="col-lg-12 pr-2 ecas-personal-info-control"
                      >
                        <Option value="">Select Country</Option>
                        {COUNTRY_LIST.map((country, index) => (
                          <Option value={country} key={index}>{country}</Option>
                        ))}
                      </Select>
                    </div>
                    <div className="col-lg-4 mt-3">
                      <input
                        type="text"
                        name="other_birth_state"
                        placeholder="State"
                        value={this.state.other_birth_state}
                        onChange={(e) =>
                          this.setState({ other_birth_state: e.target.value })
                        }
                      />
                    </div>
                    <div className="col-lg-4 mt-3">
                      <input
                        type="text"
                        name="other_birth_city"
                        placeholder="City"
                        value={this.state.other_birth_city}
                        onChange={(e) =>
                          this.setState({ other_birth_city: e.target.value })
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Current Residence (City, State within the United States):{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <div className="row">
                <div className="col-lg-4 mt-3">
                  <Select
                    value={this.state.reside_in_state}
                    onChange={(value) =>
                      this.setState({
                        reside_in_state: value,
                        other_reside_in_state: ""
                      })
                    }
                    placeholder="State"
                    className="col-lg-12 pr-2 ecas-personal-info-control"
                  >
                    {CURRENT_RESIDENCE_COUNTRY_OPTIONS.map((item, index) => (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>

                  {this.state.reside_in_state == "Other US Territory" && (
                    <input
                      type="text"
                      value={this.state.other_reside_in_state}
                      onChange={(e) =>
                        this.setState({
                          other_reside_in_state: e.target.value,
                        })
                      }
                      placeholder="Enter other US Territory"
                      className="mt-2"
                    />
                  )}
                </div>
                <div className="col-lg-4 mt-3">
                  <input
                    type="text"
                    placeholder="City"
                    name="reside_in_city"
                    value={this.state.reside_in_city}
                    onChange={(e) =>
                      this.setState({ reside_in_city: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Marital Status
              </label>
              <br />
              <Select
                onChange={(value) => this.setState({ marital_status: value })}
                value={this.state.marital_status}
                className="ecas-personal-info-control"
              >
                <Option value="">Select Marital Status</Option>
                {this.state.marital_status_list.map(
                  (item, index) => {
                    return (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    );
                  }
                )}
              </Select>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ecas-personal-info-save-later-btn"
                  onClick={() => this.save_details(false)}
                >
                  Save for Later
                  <box-icon
                    name="save"
                    color="#fff"
                    className="ecas-personal-info-save-later-icon"
                  ></box-icon>
                </button>
                <button
                  className="submit-button ml-2 ecas-personal-info-primary-btn"
                  onClick={() => this.save_details(true)}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    className="ecas-personal-info-chevron-icon"
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ecas-personal-info-prev-btn mr-3"
                  style={{ marginRight: "17px" }}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    className="ecas-personal-info-chevron-icon"
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2 ecas-personal-info-save-later-btn"
                  onClick={() => this.save_details(false)}
                >
                  Save for Later
                  <box-icon
                    name="save"
                    color="#fff"
                    className="ecas-personal-info-save-later-icon"
                  ></box-icon>
                </button>
                <button
                  className="submit-button ml-2 ecas-personal-info-primary-btn"
                  onClick={() => this.save_details(true)}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    className="ecas-personal-info-chevron-icon"
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
